import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import { Card } from 'react-toolbox/lib/card'
import Highcharts from "highcharts/highstock"

import ProjectCountsChart from "./Charts/ProjectCountsChart"
import ScheduleTrendlineChart from "./Charts/ScheduleTrendlineChart"
import LifecycleStatusChart from "./Charts/LifecycleStatusChart"
import PartnerSiteChart from "./Charts/PartnerSiteChart"
import LifecycleStatusBar from "./Charts/LifecycleStatusBar"
import SpecificationChart from "./Charts/SpecificationChart"
import AeResourcesChart from "./Charts/AeResourcesChart"
import AeRegionsChart from "./Charts/AeRegionsChart"

import {
  chartsEnum
} from './constants'
import {
  reportsSelector,
  filtersSelector
} from './selectors'
import styles from './styles.scss'


const mapStateToProps = (state) => {
  return {
    reports: reportsSelector(state),
    filters: filtersSelector(state)
  }
}

class DashboardCard extends Component {
  renderReports() {
    const {
      reports,
      filters
    } = this.props

    filters.sort(function (a, b) {
      const charts = Object.values(chartsEnum)
      return charts.findIndex(chart => chart.value == a) - charts.findIndex(chart => chart.value == b);
    });

    return filters.map((filter, index) => {
      const fullFilter = Object.values(chartsEnum).find(chart => chart.value == filter)
      const filterReport = fullFilter.multi ? reports.filter(report => report.type == filter) : reports.find(report => report.type == filter)

      if (filterReport) {
        switch (filter) {
          case 'project_counts': return <Card styleName='chartContainer' key={index}> <ProjectCountsChart report={filterReport} /> </Card>
          case 'project_schedule_trendline': return <Card styleName='chartContainer' key={index}> <ScheduleTrendlineChart report={filterReport} /> </Card>
          case 'project_lifecycle_trendline': return <Card styleName='chartContainer' key={index}> <LifecycleStatusChart report={filterReport} /> </Card>
          case 'partner_lifecycle_status': return <Card styleName='chartContainer' key={index}> <PartnerSiteChart report={filterReport} /> </Card>
          case 'project_lifecycle_status': return <Card styleName='chartContainer' key={index}> <LifecycleStatusBar report={filterReport} /> </Card>
          case 'project_specification': return <Card styleName='chartContainer' key={index}> <SpecificationChart report={filterReport} /> </Card>
          case 'ae_resources': return <Card styleName='chartContainer' key={index}> <AeResourcesChart report={filterReport} /> </Card>
          case 'ae_regions': return <Card styleName='chartContainer' key={index}> <AeRegionsChart report={filterReport} /> </Card>
        }
      } else return null
    })
  }

  render() {
    return (
      <div styleName='chartsContainer'>
        {this.renderReports()}
      </div>
    )
  }
}

const withConnect = connect(mapStateToProps, null)
const withStyle = CSSModules(styles)

export default compose(
  withConnect,
  withStyle
)(DashboardCard)
